<div class="task-item">

  <sc-loading-spinner [isLoading]="requestRunning">
    <sc-padding>
      <sc-flex>
        @if (task.type === 'CHECK') {
          <sc-icon iconClass="fa-shield-check fa-2x"></sc-icon>
        }
        @if (task.type === 'DOCUMENT') {
          <sc-icon iconClass="fa-file fa-2x"></sc-icon>
        }
        @if (task.type === 'PICTURE') {
          <sc-icon iconClass="fa-camera fa-2x"></sc-icon>
        }
        @if (task.type === 'PICTURE_SERIES') {
          <sc-icon iconClass="fa-images fa-2x"></sc-icon>
        }
        @if (task.type === 'MESSAGE') {
          <sc-icon iconClass="fa-message fa-2x"></sc-icon>
        }
        <sc-content-spacer></sc-content-spacer>
        <sc-dictionary-label dictionaryKey="dd.TASK.{{task.taskId}}.name"></sc-dictionary-label>
        <sc-content-spacer grow></sc-content-spacer>
        @if (this.task.processingHint != null && this.task.processingHint !== '') {
          <sc-action-icon iconClass="fa-question" (click)="showProcessingHint()"></sc-action-icon>
          <sc-content-spacer></sc-content-spacer>
        }

        @if (!task.done && task.type === 'MESSAGE') {
          <sc-button dictionaryKey="tmc.task-position-details.action.complete-message" (click)="completeTask()"
          ></sc-button>
        }
        @if (!task.done && task.type === 'CHECK') {
          <sc-button dictionaryKey="tmc.task-position-details.action.complete-check" (click)="completeTask()"
          ></sc-button>
        }
        @if (!task.done && task.type === 'PICTURE') {
          <ac-resource-upload usage="transport-task-image" (uploaded)="handleResourceUpload($event)"
          [metaData]="{ taskId: task.id }"></ac-resource-upload>
        }

        @if (task.type === 'DOCUMENT') {
          <sc-button dictionaryKey="tmc.task-position-details.action.complete-document" (click)="completeDocument()"
          ></sc-button>
        }

        @if (task.type === 'PICTURE_SERIES') {
          <sc-button dictionaryKey="tmc.task-position-details.action.complete-picture-series"
          (click)="completePictureSeries()"></sc-button>
        }

        @if (task.done && task.type !== 'MESSAGE' && task.type !== 'CHECK' && task.type !== 'PICTURE') {
          <sc-content-spacer></sc-content-spacer>
        }

        @if (task.done) {
          <sc-icon iconClass="fa-check fa-2x"></sc-icon>
        }

      </sc-flex>
    </sc-padding>
  </sc-loading-spinner>
</div>
